import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import HealthImg from "../../images/Healthcare.jpg";

const HealthCareHero = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${HealthImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Soft overlay for readability */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "rgba(0,0,0,0.12)",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            bgcolor: "rgba(22, 45, 180, 0.82)",
            px: { xs: 3, md: 6 },
            py: { xs: 4, md: 6 },
            width: "100%",
            maxWidth: 1180,
            mx: "auto",
          }}
        >
          <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
            {/* Left: Title */}
            <Grid item xs={12} md={5}>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                  fontSize: { xs: 35, sm: 45, md: 58 },

                  lineHeight: { xs: 1.05, md: 1.0 },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Healthcare
                <br />
                Solutions
              </Typography>
            </Grid>

            {/* Middle: Divider */}
            <Grid
              item
              xs={12}
              md={1}
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "2px",
                  height: 190,
                  bgcolor: "rgba(255,255,255,0.7)",
                }}
              />
            </Grid>

            {/* Right: Description */}
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.95)",
                  fontSize: { xs: 14, md: 16 },

                  lineHeight: 1.9,
                  fontWeight: 600,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                The Healthcare revenue concerns in the USA have become issues at
                the forefront of politics and the government. Increasing
                complexities and demanding working environments are making it
                more difficult for healthcare organizations and providers to
                find the right resources. AlphaForce will take care of it.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

const HealthCare = () => {
  return (
    <Box>
      <HealthCareHero />
      {/* Add the rest of the Healthcare page sections below */}
    </Box>
  );
};

export default HealthCare;
